define('lib/Podio.Transport.Picker',['require','underscore','jquery','lib/Podio.Store','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.Utils.Text'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var podioStore = require('lib/Podio.Store');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var utilsText = require('lib/Podio.Utils.Text');

  var dataStore = podioStore.create('picker-contacts');

  function getContactsData(mode, query, callback) {
    getContactsDataFromOptions({mode: mode, query: query, callback: callback});
  }

  function getContactsDataOnSpace(mode, query, space_id, callback) {
    getContactsDataFromOptions({mode: mode, query: query, space_id: space_id, callback: callback});
  }

  function getContactsDataFromOptions(options) {
    options = $.extend({
      mode: 'search',
      query: null,
      space_id: null,
      callback: function() {}
    }, options);

    var itemKey     = options.mode + '-' + (options.space_id ? options.space_id + '_' : '')  + options.query;
    var url         = routes.contacts_autocomplete_path();
    var requestData = { mode: options.mode , query: options.query };

    if(options.space_id) {
      requestData = $.extend({space_id: options.space_id}, requestData);
    }

    var postOptions = {
      requestData: requestData,
      abortable:   true,
      storeKey:    itemKey,
      requestKey:  itemKey
    };

    var extractItems = function(responseData) {
      if(responseData.status == 'ok') {
        return responseData.data.items;
      } else {
        return [];
      }
    };

    var xhr = transport.cachedRequest("post", "json", url, postOptions, _.compose(options.callback, extractItems));

    return xhr.then(extractItems);
  }

  function getSpacePickerData(callback, org_id, exclude_space_id, prevent_caching) {
    var itemKey = 'organizations-picker';
    var cachedData = dataStore.get(itemKey);

    if(cachedData && _.isUndefined(prevent_caching)) {
      callback.apply(this, [cachedData]);
    } else {
      var params = { abortable: true };
      if (org_id) {
        params['requestData'] = { 'org_id': org_id };
      }
      if (exclude_space_id) {
        params['requestData'] = params['requestData'] || {};
        params['requestData']['exclude_space_id'] = exclude_space_id;
      }

      transport.getJSON(routes.organizations_space_picker_path(), params, function(responseData) {
        if(responseData.status == 'ok'){
          dataStore.store(itemKey, responseData.data.organizations);
          callback.apply(this, [responseData.data.organizations]);
        } else {
          callback.apply(this, [[]]);
        }
      });
    }

  }

  function getReferenceData(query, options, callback) {
    var params = {
      abortable: true,
      requestData: {
        query: query,
        target: options.target,
        limit: options.limit || 8
      },
      storeKey: 'reference-' + options.target,
      requestKey: query
    };

    if (options.filterKey &&_.isArray(options.filterVal)) {
      _.extend(params.requestData, {
        filter_key: options.filterKey,
        filter_val: options.filterVal.toString()
      });
    }

    var req = transport.cachedRequest('get', 'json', routes.autocomplete_reference_picker_path(), params);

    // Execute callback
    req.done(function(responseData) {
      if (responseData.status === 'ok' && callback) {
        callback(responseData.data.items);
      }
    });

    // Filter the value, and return it
    return req.pipe(function(responseData) {
      if (responseData.status === 'ok') {
        return responseData.data.items;
      }
    });

  }

  function getSpaceAndItemsData(mode, query, callback) {
    return getReferenceData(query, { target: 'task_reference' }, callback);
  }

  function getSearchData(mode, query, callback) {
    var params = {
      abortable: true,
      requestData: {
        query: query,
        target: 'global_nav',
        limit: 8
      }
    };

    var url = routes.autocomplete_reference_picker_path();
    var itemKey = 'global-nav-search-{0}'.format(query);
    if (mode === 'top') {
      url = routes.autocomplete_creator_top_path();
      itemKey = 'global-nav-top';
    }

    var cachedData = dataStore.get(itemKey);

    if(cachedData) {
      callback.apply(this, [cachedData]);
    }
    else {
      return transport.getJSON(url, params, function(responseData) {
        if (responseData.status === 'ok') {
          dataStore.store(itemKey, responseData.data.items);
          callback(responseData.data.items);
        }
      });
    }

  }

  function getUsersData(mode, query, callback) {
    var requestMode;
    switch(mode) {
      case 'toplist':
        requestMode = 'toplist_users';
        break;
      case 'single':
        requestMode = 'single_user';
        break;
      case 'mention_users':
        requestMode = 'mention_users';
        break;
      default:
        requestMode = 'search_users';
        break;
    }
    return getContactsData(requestMode, query, callback);
  }

  function getContactFieldData(space_id, mode, query, callback) {
    return getContactsDataOnSpace(mode, query, space_id, callback);
  }

  function getAppFieldData(field_id, item_id, mode, query, callback) {
    var options = {
      mode: mode,
      query: query,
      field_id: field_id,
      callback: callback
    };

    var itemKey = options.mode + '-' + field_id + '-'  + options.query;
    var cachedData = dataStore.get(itemKey);

    if(cachedData) {
      options.callback.apply(this, [cachedData.data.items]);
    } else {
      var params = {
        abortable: true,
        requestData: {
          query: query,
          target: 'item_field',
          field_id: field_id,
          not_item_ids: [item_id]
        }
      };

      transport.getJSON(routes.autocomplete_reference_picker_path(), params, function(responseData) {
        if(responseData.status == 'ok'){
          dataStore.store(itemKey, responseData);
          options.callback.apply(this, [responseData.data.items]);
        }
        else {
          options.callback.apply(this, [[]]);
        }
      });
    }
  }

  function getUserApps(org_id) {
    var params = {};

    if(org_id) {
      params = {org_id: org_id};
    }

    if(this.requests && this.requests[org_id]) {
      return this.requests[org_id];
    }

    this.requests = this.requests || {};

    var reqUrl  = routes.autocomplete_user_apps_all_path(params);
    this.requests[org_id] = transport.cachedRequest('get', 'json', reqUrl, {
      abortable: true,
      storeKey :'autcomplete_user_apps',
      requestKey : 'all',
      requestData : {}
    });

    return this.requests[org_id];
  }

  function getTopUserApps(orgId, limit) {
    var params = {};

    if (orgId) {
      params = { org_id: orgId };
    }

    if (limit) {
      params = { limit: limit };
    }

    var reqUrl  = routes.autocomplete_user_apps_top_path(params);
    var req = transport.cachedRequest('get', 'json', reqUrl, {
      abortable   : true,
      storeKey    : 'autcomplete_user_apps',
      requestKey  : 'top',
      requestData : {}
    });

    return req;
  }

  function searchUserApps(orgId, query) {
    var params = {
      query : query
    };

    if(orgId) {
      params.org_id = orgId;
    }

    var reqUrl = routes.autocomplete_user_apps_search_path(params);
    var req = transport.cachedRequest('get', 'json', reqUrl, {
      abortable   : true,
      storeKey    : 'autcomplete_user_apps',
      requestKey  : 'search_{0}'.format( query ),
      requestData : {}
    });

    return req;

  }

  function filteredPickerValues(dataReq, limit, mode, query, callback) {
    dataReq.done(function(responseData) {
      if(responseData.status == 'ok'){
        var items = responseData.data.items || [];
        var filterExp = new RegExp(utilsText.regexEscape(query), "gi");

        if(query) {
          items = _.filter(items, function(item, index) {
            return item.name.search(filterExp) > -1;
          });
        }
        items = _.first(items, limit);

        callback.apply(this, [items]);
      }
      else {
        callback.apply(this, [[]]);
      }
    });
  }

  function getTaskResponsibleData(query, callback) {
    var reqUrl = routes.autocomplete_task_responsible_path({ 'query': query });
    var req = transport.cachedRequest('get', 'json', reqUrl, {
      abortable   : true,
      storeKey    : 'autcomplete_task_responsible',
      requestKey  : 'search_{0}'.format( query ),
      requestData : {}
    });

    return req;
  }

  return {
    filteredPickerValues: filteredPickerValues,
    getContactsData: getContactsData,
    getContactsDataOnSpace: getContactsDataOnSpace,
    getContactsDataFromOptions: getContactsDataFromOptions,
    getSpacePickerData: getSpacePickerData,
    getSpaceAndItemsData: getSpaceAndItemsData,
    getReferenceData: getReferenceData,
    getSearchData: getSearchData,
    getUsersData: getUsersData,
    getContactFieldData: getContactFieldData,
    getAppFieldData: getAppFieldData,
    getUserApps: getUserApps,
    getTopUserApps: getTopUserApps,
    searchUserApps: searchUserApps,
    getTaskResponsibleData: getTaskResponsibleData
  };

});

